import React from 'react'
import { Col } from 'react-bootstrap'

import Field from '../../../../../../Field'
import RadioSelect from '../../../../../../RadioSelect'
import { IFilterType } from '../../../../../types'

const ThreesidedType = (props: IFilterType): React.ReactElement => {
  const { filter, index } = props

  const { colWidth, name = '', hideLabel, label, options } = filter || {}

  return (
    <Col md={colWidth ? colWidth : 6} key={index}>
      <Field name={name} label={!hideLabel && label && `${label}`}>
        <RadioSelect spacing="0.50em" options={options} />
      </Field>
    </Col>
  )
}

export default ThreesidedType
